import { handleResponse, handleBlobResponse } from "utils/utils";
import { authService } from "services";

export const staffingLevelsService = {
    getAll,
    getSelectable,
    getById,
    add,
    update,
    remove,
    clone,
    getStaffingLevelAssignments,
    getStaffingLevelCurrentAssignments,
    getStaffingLevelHourlyAssignments,
    updateAssignment,
    deleteOverwrites,
    downloadImportTemplate,
    prepareImport,
    runImport,
};

// gets all staffing-levels
function getAll(q) {

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    let query = "?sort=+name&page_size=1000&variant=select";

    if (q !== undefined)
        query += "&q=" + q;

    return fetch(`${global.BASE_API}staffing-levels${query}`, requestOptions).then(handleResponse);
}

function getSelectable() {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    let query = '?sort=+name&variant=select&enabled=true';

    return fetch(`${global.BASE_API}staffing-levels${query}`, requestOptions).then(handleResponse);
}

// get one staffing-level by id
function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}staffing-levels/${id}`, requestOptions).then(handleResponse);
}

// add new staffing-level
function add(staffing_level) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(staffing_level)
    };

    return fetch(`${global.BASE_API}staffing-levels/`, requestOptions).then(handleResponse);
}

// update staffing-level
function update(staffing_level) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(staffing_level)
    };

    return fetch(`${global.BASE_API}staffing-levels/${staffing_level.id}`, requestOptions).then(handleResponse);
}

// remove staffing-level
function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}staffing-levels/${id}`, requestOptions).then(handleResponse);
}

// clone staffing-level
function clone(id) {
    const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${authService.token.access_token}`,
        },
    };

    return fetch(`${global.BASE_API}staffing-levels/${id}/clone`, requestOptions).then(
        handleResponse
    );
}


// gets staffing level assignments
function getStaffingLevelAssignments(options) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    const { group_id, employee_id, start, end, function_id, function_ids, ubication_id } = options;


    let query = "?page_size=1000&start=" + start + "&end=" + end;

    if (group_id !== undefined && group_id > 0)
        query += "&group_id=" + group_id;

    if (employee_id !== undefined && employee_id > 0)
        query += "&employee_id=" + employee_id;

    //console.log(plan_view_id);

    if (Array.isArray(function_ids) && function_ids.length > 0) {
        function_ids.forEach((id) => {
            const numericId = parseInt(id, 10);
            if (!Number.isNaN(numericId) && numericId > 0) {
                query += "&function_ids=" + numericId;
            }
        });
    } else if (function_id !== undefined && function_id > 0) {
        query += "&function_id=" + function_id;
    }

    if (ubication_id !== undefined && ubication_id > 0)
        query += "&ubication_id=" + ubication_id;

    return fetch(`${global.BASE_API}staffing-levels/assignments${query}`, requestOptions).then(handleResponse);
}

// gets staffing level CURRENT assignments (cuando staffing level assignments no devuelve nada)
function getStaffingLevelCurrentAssignments(options) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    const { group_id, employee_id, start, end, function_id, function_ids, ubication_id } = options;


    let query = "?start=" + start + "&end=" + end;

    if (group_id !== undefined && group_id > 0)
        query += "&group_id=" + group_id;

    if (employee_id !== undefined && employee_id > 0)
        query += "&employee_id=" + employee_id;

    //console.log(plan_view_id);

    if (Array.isArray(function_ids) && function_ids.length > 0) {
        function_ids.forEach((id) => {
            const numericId = parseInt(id, 10);
            if (!Number.isNaN(numericId) && numericId > 0) {
                query += "&function_ids=" + numericId;
            }
        });
    } else if (function_id !== undefined && function_id > 0) {
        query += "&function_id=" + function_id;
    }

    if (ubication_id !== undefined && ubication_id > 0)
        query += "&ubication_id=" + ubication_id;

    return fetch(`${global.BASE_API}staffing-levels/current-assignments${query}`, requestOptions).then(handleResponse);
}


// gets staffing level assignments HOURLY
function getStaffingLevelHourlyAssignments(options) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    const {
        group_id,
        start,
        end,
        start_hour,
        end_hour,
        function_id,
        function_ids,
        ubication_id,
    } = options;

    let query = "?start=" + start + "&end=" + end + "&fractionMinutes=15";

    if (group_id !== undefined && group_id > 0)
        query += "&group_id=" + group_id;

    if (start_hour !== undefined && start_hour !== "")
        query += "&start_hour=" + start_hour;

    if (end_hour !== undefined && end_hour !== "")
        query += "&end_hour=" + end_hour;

    if (Array.isArray(function_ids) && function_ids.length > 0) {
        function_ids.forEach((id) => {
            const numericId = parseInt(id, 10);
            if (!Number.isNaN(numericId) && numericId > 0) {
                query += "&function_ids=" + numericId;
            }
        });
    } else if (function_id !== undefined && function_id > 0) {
        query += "&function_id=" + function_id;
    }

    if (ubication_id !== undefined && ubication_id > 0)
        query += "&ubication_id=" + ubication_id;

    return fetch(`${global.BASE_API}staffing-levels/assignments/fractioned${query}`, requestOptions).then(handleResponse);
}


// PUT update staffing level assignments
function updateAssignment(overwrite) {
    const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${authService.token.access_token}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(overwrite),
    };

    return fetch(`${global.BASE_API}staffing-levels/overwrites`, requestOptions).then(
        handleResponse
    );
}

// DELETE staffing level overwrites for a period and group
function deleteOverwrites(options) {
    const { start, end, group_id } = options;

    const requestOptions = {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${authService.token.access_token}`,
        },
    };

    let query = `?start=${start}&end=${end}`;

    if (group_id !== undefined && group_id > 0) {
        query += `&group_id=${group_id}`;
    }

    return fetch(`${global.BASE_API}staffing-levels/overwrites${query}`, requestOptions).then(
        handleResponse
    );
}


/**********************************************************************
 ****** IMPORT STAFFING LEVELS
 ***********************************************************************/

function downloadImportTemplate() {
    const requestOptions = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${authService.token.access_token}`,
            "Content-Type": "application/json",
        },
    };

    return fetch(
        `${global.BASE_API}staffing-levels/imports/template`,
        requestOptions
    ).then(handleBlobResponse);
}

function prepareImport(formData) {
    const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${authService.token.access_token}`,
        },
        body: formData,
    };

    return fetch(`${global.BASE_API}staffing-levels/imports`, requestOptions).then(
        handleResponse
    );
}

function runImport(token) {
    const requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${authService.token.access_token}`,
        },
    };

    return fetch(
        `${global.BASE_API}staffing-levels/imports/${token}`,
        requestOptions
    ).then(handleResponse);
}